<template>
  <div class="realize_wrap">
    <div class="realize_img"></div>
    <!--已投企业-->
    <div class="enterprise">
      <div class="enterprise_title">{{$t("homeAbout.portfolioCompanies")}}</div>
      <div class="enterprise_en">{{$t("homeAbout.portfolioCompaniesEn")}}</div>
      <div class="company_presentation">
        <img class="company_listed" src="@/assets/img/home/1745566970_mvZe.png" alt=""/>
        <div class="will">
          <div v-animate-on-scroll="'animate__slideInUp'">
            <div class="will_title">{{$t("homeAbout.willTitle")}}</div>
            <div class="will_en">{{$t("homeAbout.willEn")}}</div>
          </div>
        </div>
        <el-row class="card_wrap" type="flex" v-animate-on-scroll="'animate__slideInUp'">
          <el-col
              class="brain_item"
              :span="6"
              :lg="7"
              :sm="11"
              :xs="11"
              v-for="(item, index) in cardList"
              :key="index"
          >
            <div class="card_img" @click.prevent.stop="handleToDemo(index + 1)">
              <img class="item_card_img" :src="item.bgImg"  alt="">
            </div>
            <div class="item_title" @click.prevent.stop="handleToDemo(index + 1)">{{ item.title }}</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <CallMe />
  </div>
</template>

<script>
/* eslint-disable */
import CallMe from '@/components/callme/index'
export default {
  computed: {
    cardList() {
      return [
        {
          title: this.$t("homeAbout.company1"),
          bgImg:require("@/assets/img/home/1745567661_JDNx.jpg")
        },
        {
          title: this.$t("homeAbout.company4"),
          bgImg:require("@/assets/img/home/1745567632_njYg.jpg")
        },
        {
          title: this.$t("homeAbout.company3"),
          bgImg:require("@/assets/img/home/1745567642_knlZ.jpg")
        },
        {
          title: this.$t("homeAbout.company2"),
          bgImg:require("@/assets/img/home/1745567661_usaK.jpg")
        }
      ]
    }
  },
  data() {
    return {
    }
  },
  methods: {
    handleToDemo(index)
    {
      this.$router.push('/portfolio-companies/' + index)
    },
  },
  components: {
    CallMe
  },
  created(){
    this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
  },
  mounted() {
  },
  watch: {
    $route() {
      this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    },
  },
}
</script>

<style lang="scss" scoped>
.realize_wrap {
  position: relative;
  font-family: $font-family;
  background-color: #f6f7f9;
  .realize_img {
    width: 100%;
    height: 600px;
    overflow: hidden;
    background-image: url('../../assets/img/other/1749520018_lP3M.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    @media screen and (max-width: 768px) {
      height: 50vw;
      background-size: 100% 100%;
    }
  }
  //已投企业
  .enterprise{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 100px;
    .enterprise_title{
      position: relative;
      color: #203040;
      font-size: $title-font-size;
      font-weight: bold;
      padding: 30px 0 0 0;
      @media screen and (max-width: 768px) {
        font-size: $phone-title-font-size;
        padding-top: 2rem;
      }
    }
    .enterprise_en{
      color: #fccc0c;
      font-size: $subtitle-font-size;
      @media screen and (max-width: 768px) {
        font-size: $phone-subtitle-font-size;
      }
    }
    .company_presentation{
      position: relative;
      width: 100%;
      display: flex;
      .company_listed{
        height: 500px;
        position: absolute;
        width: 100%;
        object-fit: fill;
        top: -70px;
        @media screen and (max-width: 768px) {
          height: 20rem;
          object-fit: cover;
          top:-2.5rem;
        }
      }
      .will{
        color: #ffffff;
        position: absolute;
        top: 80px;
        left: 50%;
        transform: translateX(-50%);
        @media screen and (max-width: 768px) {
          top: 5rem;
        }
        .will_title{
          text-align: center;
          font-size: 2rem;
          line-height: 1.5;
          @media screen and (max-width: 768px) {
            font-size: 1.6rem;
          }
        }
        .will_en{
          display: flex;
          line-height: 1.5;
          font-size: 2.1rem;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 1.4rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .card_wrap {
    width: 70%;
    margin: 200px auto 0 auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      flex-wrap: wrap;
      justify-content: space-around;
      margin-top: 11rem;
    }
    .brain_item {
      transition: background-color 1s;
      margin-right: 15px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40PX;
        border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20PX;
        &:nth-child(-n+2){
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 30px;
      position: relative;
      .item_title {
        transition: all 0.5s;
        font-size: $content-font-size;
        color: #203040;
        text-align: center;
        padding: 12px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 0.8rem;
          text-align: center;
        }
      }
      .card_img{
        display: flex;
        width: 100%;
        max-width: 100%;
        overflow: hidden;
        border-radius: 20px 20px 0 0;
        .item_card_img{
          border-radius: 20px 20px 0 0;
          height: 100%;
          width: 100%;
          transition: transform 0.3s ease;  /* 添加过渡效果，使放大过程更平滑 */
          object-fit: contain;  /* 保证图片在容器内不会失真 */
          @media screen and (max-width: 768px) {
            border-radius: 0.6rem 0.6rem 0 0;
          }
        }
      }
      .item_navigate {
        width: 100PX;
        height: 30PX;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10PX;
          font-size: 14px;
        }
      }
      &:hover {
        cursor: pointer;
        background: #794bb7;
        .item_title{
          color: #fff;
        }
        .item_card_img{
          transform: scale(1.1);
          transition: transform 0.5s;
        }
      }
    }
  }
}
</style>
